var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 682.66669 682.66669",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", {
    id: "defs664",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath674",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path672",
    fill: "#000000",
    "data-original": "#000000",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g666",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g668",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g670",
    clipPath: "url(#clipPath674)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g676",
    transform: "translate(309.7412,384.5171)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -53.741,-30 -107.482,0 V 107.483 H 0 Z",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path678",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g680",
    transform: "translate(202.2588,438.2588)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -106.259 v -418.259 h 320 V 0 H 107.482",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path682",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g684",
    transform: "translate(176,243.0117)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 160",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path686",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g688",
    transform: "translate(176,131.5059)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 160",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path690",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.5c8cfd703d7d50af9cde2b77c0e30757.svg";
export { ForwardRef as ReactComponent };